import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

/**
 * Interceptor to add a mock JWT to all outgoing HTTP requests.
 */
@Injectable()
export class MockJwtInterceptor implements HttpInterceptor {
  private readonly mockJwt = environment.staticBearerToken ?? 'MOCK_TOKEN';

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Only attach static bearer when running in no-auth mode
    if (environment.noAuthMode) {
      const authReq = req.clone({
        setHeaders: {
          Authorization: `Bearer ${this.mockJwt}`,
        },
      });
      return next.handle(authReq);
    }
    return next.handle(req);
  }
}
